import React, { Component } from 'react'
import ArticleRefinement from './article-refinement'
import { Index } from 'react-instantsearch-dom'

export default class ArticleFilters extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { hits, type, algoliaConfig } = this.props
    return (
      <div className="article-filter-wrapper">
        <Index indexName={algoliaConfig.articles}>
          <ul
            id="article-filter"
            className="article-filter inline wide"
            data-element="category"
            data-change-title="true"
          >
            <li className="margin-right-1x article-tab">
              <a href="/blogs/resources">Show All</a>
            </li>
            <ArticleRefinement attribute="blog.title" />
            <ArticleRefinement attribute="named_tags.content_type" />
          </ul>
        </Index>
      </div>
    )
  }
}
